/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { createFilterComponent as o } from "./FilterComponent.mjs";
import { DatePicker as r } from "@progress/kendo-react-dateinputs";
import { DropDownList as m } from "@progress/kendo-react-dropdowns";
const n = {
  inputComponent: (e) => /* @__PURE__ */ t.createElement(r, { ...e }),
  operatorComponent: (e) => /* @__PURE__ */ t.createElement(m, { ...e }),
  emptyFilter: { operator: "eq", value: null }
};
class l extends o(n) {
}
export {
  l as DateFilterCell
};
